namespace GeniuzPOS.ReportMasterData {
    export interface Report_1503_NRow {
        Id?: string;
        Year?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        TypeSum?: string;
        January?: number;
        February?: number;
        March?: number;
        April?: number;
        May?: number;
        June?: number;
        July?: number;
        August?: number;
        September?: number;
        October?: number;
        November?: number;
        December?: number;
    }

    export namespace Report_1503_NRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1503_N';
        export const deletePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const insertPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const readPermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';
        export const updatePermission = '1POSBASE:รายงาน:เปรียบเทียบ:ยอดขายรายเดือน:View';

        export declare const enum Fields {
            Id = "Id",
            Year = "Year",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            TypeSum = "TypeSum",
            January = "January",
            February = "February",
            March = "March",
            April = "April",
            May = "May",
            June = "June",
            July = "July",
            August = "August",
            September = "September",
            October = "October",
            November = "November",
            December = "December"
        }
    }
}
